import React from 'react';
import { useSelector } from 'react-redux';
import logo from '@assets/images/logo.png';
import { Link } from 'react-router-dom';
const slugify = (text) => {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w\-]+/g, "")
    .replace(/\-\-+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");
};
const ReviewsCategories = () => {
  // JSON data for categories with common image
  const { categories, isLoading, error } = useSelector(state => state?.category);
  const categoriesData = {
    title: "yslearn Reviews & Stories From Other Categories",
    commonImage: logo,
  };

  return (
    <div className="max-w-full mx-auto p-6 md:p-12 bg-[#f2f5fa]">
      <div className="max-w-7xl mx-auto">
        {/* Title */}
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-8 md:mb-12">
          {categoriesData.title}
        </h2>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
          {categories?.map((category) => (
            <div
              key={category.id}
              className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-all duration-300 cursor-pointer hover:scale-105 group"
            >
              <div className="flex items-center space-x-4">
                {/* Image Container */}
                <div className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300 bg-gray-50">
                  <img
                    src={categoriesData.commonImage}
                    alt={category.name}
                    className="w-8 h-8 object-contain"
                  />
                </div>

                {/* Category Name */}
                <div className="text-gray-700 font-semibold text-base md:text-lg leading-tight">
                  <Link
                    to={`/categories/${slugify(category.categoryName)}/${category.id}`}
                    className="!hover:text-white !text-[#848484]"
                    state={{ category: category }}
                  >
                    {category.categoryName}
                  </Link>

                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReviewsCategories;